import { render, staticRenderFns } from "./SearchAccommodations.vue?vue&type=template&id=5b5bd965&scoped=true"
import script from "./SearchAccommodations.vue?vue&type=script&lang=js"
export * from "./SearchAccommodations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5bd965",
  null
  
)

export default component.exports